export const newsYouCanUseModule = {
  name: 'News U Can Use',
};
